import { ColDef } from "ag-grid-community";
import { BillingDailyNotesComponent } from "./billing-daily-notes.component";

export const colDefs = (component: BillingDailyNotesComponent): ColDef[] => [
  {
    field: "patientName",
    headerName: "Patient",
    sortable: true,
    headerCheckboxSelection: true,
    checkboxSelection: true,
    showDisabledCheckboxes: false
  },
  { field: "discipline", headerName: "Disc", sortable: true },
  { field: "date", headerName: "Date of Bill/Daily Note", sortable: true },
  { field: "requestedBy", headerName: "Assistant", sortable: true },
  {
    field: "view",
    headerName: "View Panel",
    cellRenderer: (params: any) => {
      const link = document.createElement("a");
      const isDisabled = params.data;
      link.innerHTML = "View&#x25BE;";
      link.style.cursor = "pointer";
      link.style.color = "blue";

      link.addEventListener("click", (event) => {
        if (params.node) {
          params.node.setExpanded(!params.node.expanded);
        }
        link.innerHTML = params.node.expanded ? "View&#x25B4;" : "View&#x25BE;";
      });
      return link;
    },
  },
];
